import { Component, Input, OnInit } from "@angular/core";
import { MatRadioChange } from "@angular/material/radio";
import { AssistantActionButton, AssistantContentMessage } from "../../../models";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-popup-content-message",
    templateUrl: "./assistant-popup-content-message.component.html",
    styleUrls: ["./assistant-popup-content-message.component.scss"],
    standalone: false
})
export class AssistantPopupContentMessageComponent implements OnInit {
  @Input() message: AssistantContentMessage;

  constructor(private assisantService: AssistantService) {}

  ngOnInit(): void {}

  onRadioChange(e: MatRadioChange): void {
    const radio = this.message.radioButtons.find(i => i.value === e.value);

    this.assisantService.raiseRadioButton(this.message, radio);
  }

  onActionBtnClick(btn: AssistantActionButton): void {
    this.assisantService.raiseActionButton(btn);
  }
}
